export default __webpack_public_path__ + "static/media/ActiveEye.656eaa45.svg";